import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: './water-supply-chart-dialog.component.html',
  styleUrls: ['./water-supply-chart-dialog.component.scss']
})
export class WaterSupplyChartDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      staticPressure?: number;
      residualPressure?: number;
      flowRate?: number;
      systemFlow?: number;
      systemDemand?: number;
    }
  ) {}
}
